"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const TooltipPortal_1 = __importDefault(require("components/shared/Tooltips/TooltipPortal"));
const TooltipContainer = ({ tooltipClass = '', show, text, children, classContainer, position = 'top', align = 'middle', onClick, dataCy, customStyle, wrap = false, dataCyTooltip, useMaxWidth = true, textChangeable = false, callbackRef, tooltipContent }) => {
    const [portalData, setPortalData] = (0, react_1.useState)({});
    const [clientRect, setClientRect] = (0, react_1.useState)();
    const [isTooltipShown, setIsTooltipShown] = (0, react_1.useState)(false);
    const timeoutId = (0, react_1.useRef)(null);
    const setPortal = () => {
        if (show) {
            const rect = clientRect && (clientRect === null || clientRect === void 0 ? void 0 : clientRect.getBoundingClientRect());
            setIsTooltipShown(true);
            const portalData = {
                name: (0, HelperUtils_1.getObjectiveLocale)(text),
                noWrap: !wrap
            };
            text && (portalData.name = (0, HelperUtils_1.getObjectiveLocale)(text));
            tooltipContent && (portalData.tooltipContent = tooltipContent());
            if (rect) {
                if (align == 'left')
                    portalData.left = rect === null || rect === void 0 ? void 0 : rect.left;
                if (align == 'middle') {
                    portalData.left = (rect === null || rect === void 0 ? void 0 : rect.left) + (rect === null || rect === void 0 ? void 0 : rect.width) / 2;
                    portalData.translateX = '-50%';
                }
                if (align == 'right') {
                    portalData.left = rect === null || rect === void 0 ? void 0 : rect.right;
                    portalData.translateX = '-100%';
                }
                if (position == 'top') {
                    portalData.top = (rect === null || rect === void 0 ? void 0 : rect.top) - 8;
                    portalData.translateY = '-100%';
                }
                if (position == 'bottom') {
                    portalData.top = (rect === null || rect === void 0 ? void 0 : rect.bottom) + 8;
                }
            }
            setPortalData(portalData);
        }
    };
    const handleRef = (ref) => {
        setClientRect(ref);
        callbackRef && callbackRef(ref);
    };
    const onMouseEnter = () => {
        timeoutId.current = setTimeout(() => {
            setPortal();
        }, 500);
    };
    const onMouseLeave = () => {
        setIsTooltipShown(false);
        (timeoutId === null || timeoutId === void 0 ? void 0 : timeoutId.current) && clearTimeout(timeoutId.current);
    };
    (0, react_1.useEffect)(() => {
        if (textChangeable && isTooltipShown) {
            setPortalData((data) => {
                return Object.assign(Object.assign({}, data), { name: 'aaa' });
            });
        }
    }, [text, setPortalData, isTooltipShown, textChangeable]);
    (0, react_1.useEffect)(() => {
        !show && onMouseLeave();
    }, [show]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TooltipPortal_1.default, { show: isTooltipShown, portalData: portalData, portalId: 'shared-tooltip', className: `${tooltipClass} ${useMaxWidth ? 'max-w-[240px]' : ''}`, dataCy: dataCyTooltip }),
        react_1.default.createElement("div", { className: `${classContainer ? classContainer : ''}`, ref: (ref) => ref && handleRef(ref), onMouseEnter: () => onMouseEnter(), onMouseLeave: () => onMouseLeave(), onPointerLeave: () => onMouseLeave(), "data-cy": dataCy, onClick: onClick, style: customStyle }, children)));
};
exports.default = TooltipContainer;
